module.exports = function getResource(label, vars = []) {
    const resources = {
        modalTitle: 'Add Your Beauty Preferences',
        skipThisQuestion: 'Skip this question',
        next: 'Next',
        done: 'Done',
        modalSubTitle1: 'Congratulations! You are now a Beauty Insider.',
        modalSubTitle2: 'Tell us more about yourself to get a personalized shopping experience.',
        apiErrorModalTitle: 'Changes Not Saved',
        apiErrorModalMessage: 'Oops, something went wrong while trying to process your submission. Please try again.',
        buttonText: 'Got It',
        savedTitle: 'Beauty Preferences Saved',
        savedMessage1: 'Your preferences have been saved. Go to your Beauty Preferences to ',
        linkText: 'edit your answers',
        savedMessage2: ' or tell us more.',
        keepGoing: 'Keep Going'
    };

    return resources[label];
};
